/**
 * A function to return the formatted district for a congressperson.
 * For house members, it will return in the format (District x) or (At-large);
 * for senate it will return an empty string.
 * @param {string} district - The district (Number or empty string)
 * @returns {string} - The district's formatted string, or n
 */
export default function getDistrict(district) {
  if ('' === district) {
    return '';
  } else if (0 === district) {
    return '(At-large)';
  } else if ('number' === typeof (district)) {
    return `(District ${district})`;
  }
  return '';
}
